import { AttachmentImage, AttachmentVideo } from './file';

export enum Locale {
  SA = 'ar-SA',
  DE = 'de-DE',
  AU = 'en-AU',
  GB = 'en-GB',
  US = 'en-US',
  ES = 'es-ES',
  FR = 'fr-FR',
  GR = 'el-GR',
  IL = 'he-IL',
  IT = 'it-IT',
  JP = 'ja-JP',
  KR = 'ko-KR',
  MY = 'ms-MY',
  PT = 'pt-PT',
  RU = 'ru-RU',
  TH = 'th-TH',
  PH = 'tl-PH',
  CN = 'zh-CN',
  HK = 'zh-HK',
  TW = 'zh-TW',
}

export const UiLocale = {
  US: Locale.US,
  CN: Locale.CN,
  HK: Locale.HK,
  TW: Locale.TW,
  JP: Locale.JP,
  // KR: Locale.KR,
  // FR: Locale.FR,
  // IT: Locale.IT,
  // ES: Locale.ES,
  // DE: Locale.DE,
} as const;
export type UiLocale = (typeof UiLocale)[keyof typeof UiLocale];

export const TtsLocale = {
  SA: Locale.SA,
  DE: Locale.DE,
  AU: Locale.AU,
  GB: Locale.GB,
  US: Locale.US,
  ES: Locale.ES,
  FR: Locale.FR,
  GR: Locale.GR,
  IL: Locale.IL,
  IT: Locale.IT,
  JP: Locale.JP,
  KR: Locale.KR,
  PT: Locale.PT,
  RU: Locale.RU,
  CN: Locale.CN,
  HK: Locale.HK,
  TW: Locale.TW,
} as const;
export type TtsLocale = (typeof TtsLocale)[keyof typeof TtsLocale];

export const EnTtsPreferences = {
  AU: Locale.AU,
  GB: Locale.GB,
  US: Locale.US,
} as const;
export type EnTtsPreferences =
  (typeof EnTtsPreferences)[keyof typeof EnTtsPreferences];

export const ZhTtsPreferences = {
  CN: Locale.CN,
  HK: Locale.HK,
} as const;
export type ZhTtsPreferences =
  (typeof ZhTtsPreferences)[keyof typeof ZhTtsPreferences];

export interface TtsPreferences {
  en: EnTtsPreferences;
  zh: ZhTtsPreferences;
}

export const I18nLocale = {
  SA: Locale.SA,
  DE: Locale.DE,
  AU: Locale.AU,
  GB: Locale.GB,
  US: Locale.US,
  ES: Locale.ES,
  FR: Locale.FR,
  GR: Locale.GR,
  IL: Locale.IL,
  IT: Locale.IT,
  JP: Locale.JP,
  KR: Locale.KR,
  MY: Locale.MY,
  PT: Locale.PT,
  RU: Locale.RU,
  TH: Locale.TH,
  PH: Locale.PH,
  CN: Locale.CN,
  HK: Locale.HK,
  TW: Locale.TW,
} as const;
export type I18nLocale = (typeof I18nLocale)[keyof typeof I18nLocale];

// english is spaceBounded
export const isSpaceBounded = (locale: Locale) =>
  ![Locale.CN, Locale.JP, Locale.HK, Locale.TW, Locale.KR].includes(locale);

// TODO: move to other place
export enum CarouselOnClickType {
  Default = 'default',
  Url = 'url',
  Page = 'page',
}

export enum CarouselOnClickPage {
  AvatarStore = 'avatarStore',
}

export type CarouselItem = {
  image?: AttachmentImage;
  video?: AttachmentVideo;
  title?: string;
  subtitle?: string;
  onClick?: {
    type: CarouselOnClickType;
    url?: string;
    page?: CarouselOnClickPage;
  };
};

// In i18nInfo, resources must have at least default locale key while others are optional
export type I18n<R, L extends I18nLocale = I18nLocale> = {
  [I in L]: {
    resources: { [i in I]: R } & {
      [k in Exclude<I18nLocale, I>]?: R;
    };
    defaultLocale: I;
  };
}[L];
